import React, { Component } from 'react'
import { translate } from 'react-i18next'

class VCGitemCustomPostDate extends Component {
  render() {
    const monthNames = this.props.t('months', { returnObjects: true })
    return (
      <div className={this.props.className}>
        <span className='day'>{this.props.date.getDate()}</span>
        <span className='month'>{monthNames[this.props.date.getMonth()]}</span>
        <span className='year'>{this.props.date.getFullYear()}</span>
      </div>
    )
  }
}

export default translate()(VCGitemCustomPostDate)


// WEBPACK FOOTER //
// ./src/custom/components/VCGitemCustomPostDate.js